import script from "./AgeSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AgeSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__